import { render, staticRenderFns } from "./ThgCustomerDetails.vue?vue&type=template&id=6c156184"
import script from "./ThgCustomerDetails.vue?vue&type=script&lang=ts"
export * from "./ThgCustomerDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports